import { Typography } from '@sonnen/web-ui';
import styles from './TariffBenefitCard.module.css';

interface TariffBenefitCardProps {
  title: string;
  value: string;
  dataTestId?: string;
}

const TariffBenefitCard = ({ title, value, dataTestId }: TariffBenefitCardProps) => {
  return (
    <div className={styles.benefitCard} data-testid={dataTestId}>
      <Typography.Number4>{value}</Typography.Number4>
      <Typography.Body1 variant="secondary">{title}</Typography.Body1>
    </div>
  );
};

export default TariffBenefitCard;
